import { render, staticRenderFns } from "./appInfo.vue?vue&type=template&id=1814ed86&"
import script from "./appInfo.vue?vue&type=script&lang=ts&"
export * from "./appInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports